<template>
  <vue-slider
    v-model="DATA"
    @change="handleChange"
    dotSize="16"
    :width="width"
    :adsorb="true"
    :contained="false"
    :tooltip="'none'"
    :min="min"
    :max="max"
    :interval="interval"
    :disabled="disabled"
    :data="data"
    :marks="marks"
  ></vue-slider>
</template>

<script>
import VueSlider from 'vue-slider-component'
export default {
  name: 'slider',
  components: {
    VueSlider,
  },
  props: {
    value: {
      type: String | Number,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 100,
    },
    interval: {
      type: Number,
      default: 1,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    width: {
      type: Number | String,
      default: 'auto',
    },
    data: {
      type: Array | Object,
      default: undefined,
    },
    marks: {
      type: Boolean,
      default: false,
    },
  },
  // 初始化
  created() {
    this.DATA = this.value
  },
  data() {
    return {
      // v-model不能直接修改props的值，所以重新建立一個data
      DATA: '',
    }
  },
  watch: {
    // 監聽props，修改v-model="DATA"
    value(val) {
      this.DATA = val
    },
  },
  methods: {
    // emit發送改變後的值到父組件
    handleChange(value) {
      this.$emit('change', value)
    },
  },
}
</script>

<style lang="scss">
$themeColor: rgb(64, 124, 205);
@import 'vue-slider-component/lib/theme/antd.scss';
</style>
